import type { PiniaColadaPlugin, QueryCache, UseQueryEntryFilter } from '@pinia/colada';

import { watch } from 'vue';

function dropEntries(queryCache: QueryCache, filters: UseQueryEntryFilter) {
  for (const entry of queryCache.getEntries(filters)) {
    queryCache.cancel(entry);
    queryCache.remove(entry);
  }
}

/**
 * Drops cached queries when the signed-in user changes (logout, impersonation start); mounted ones
 * refetch instead, since a removed entry stays orphaned in its `useQuery`. Keys carry brand ids, not
 * the user, so otherwise a later user in the same SPA reads the previous user's entries until
 * `gcTime`. On logout everything is dropped, mounted included: the old token is still live then, so a
 * refetch would re-cache the old user's data. The first identity load (no previous user) keeps the cache.
 */
export function PiniaColadaClearOnUserChange(userId: () => unknown): PiniaColadaPlugin {
  return ({ queryCache, scope }) => {
    scope.run(() => {
      watch(userId, (id, previousId) => {
        if (previousId == null) return;
        if (id == null) {
          dropEntries(queryCache, {});
        } else {
          dropEntries(queryCache, { active: false });
          void queryCache.invalidateQueries();
        }
      });
    });
  };
}
